<template>
    <div class="dashboard-page bold tablec">
        <div class="d-flex flex-row">
            <Widget title="Awards" class="shares-widget w-100">
                <div class="display-flex mt-4">
                    <b class="mr-2">Legend: </b>
                    <div class="mr-3">
                        <i class="fa fa-circle text-success"></i> <span> Public & country specific</span>
                    </div>
                    <div class="mr-3">
                        <i class="fa fa-circle text-inverse"></i> <span> Not public & country specific</span>
                    </div>
                    <div class="mr-3">
                        <span class="glyphicon glyphicon-globe pb-1" style="color: #3abf94"/>
                        <span> Public & global</span>
                    </div>
                    <div class="mr-3">
                        <span class="glyphicon glyphicon-globe pb-1" style="color: #495057"/>
                        <span> Not public & global</span>
                    </div>
                </div>
                <b-button variant="success" @click="$router.push(`/app/content/awards/create`)" v-if="hasAdminRole()"
                          class="mb-3 mt-3">
                    Add new award
                </b-button>
                <h6 v-if="awards.length == 0" class="p-2">
                    No awards added yet.
                </h6>
                <div class="list-group list-group-lg">
                    <div href="#" style="align-items: center" class="list-group-item display-flex" v-for="award in awards" :key="award.id" >
                        <span class="thumb-xl mr" style="width: 100px">
                          <img :src="award.downloadUrl" alt="..." />
                        </span>
                        <div style="width:70%">
                            <h4 class="">
                                <span class="glyphicon glyphicon-globe pb-1"
                                      :style="{color: award.public? '#3abf94' : '#495057'}"
                                      style="color: #3abf94" v-if="award.global"/>
                                <i v-else class="fa fa-circle" :class="'text-' + (award.public ? 'success' : 'inverse')"></i>
                                {{award.title}}
                            </h4>
                            <h6>{{award.description}}</h6>
                        </div>
                        <div class="ml-auto" v-if="hasAdminRole(award.global)">
                            <span class="glyphicon glyphicon-pencil icon-button p-1"
                                  @click="$router.push(`/app/content/awards/${award.id}`)"/>
                            <span :id="'popoverDeleteAward_' + award.id" v-if="!award.isAssociatedWithBehaviours"
                                  class="glyphicon glyphicon-remove icon-button p-1"/>
                            <b-popover class="popover-danger"
                                       triggers="click"
                                       :target="'popoverDeleteAward_' + award.id"
                                       :show.sync="awardPopover[award.id]"
                                       placement="top"
                            >
                                <template slot="title">
                                    <div class="px-5">Are you sure you want to delete this award?</div>
                                </template>
                                <div class="px-5 d-flex justify-content-center">
                                    <b-button-toolbar>
                                        <b-button variant="success" size="xs"
                                                  @click="deleteAwardRequest({award, $toasted})">
                                            Yes
                                        </b-button>
                                        <b-button variant="danger" size="xs"
                                                  @click="closePopover(award.id)">
                                            No
                                        </b-button>
                                    </b-button-toolbar>
                                </div>
                            </b-popover>
                        </div>
                    </div>
                </div>
            </Widget>
        </div>
    </div>
</template>

<script>
  import Loader from "../../components/Loader/Loader";
  import {mapActions, mapState} from "vuex";
  import Widget from "../../components/Widget/Widget";
  import vSelect from "vue-select";
  import moment from 'moment';

  export default {
    name: "Behaviours",
    components: {Loader, Widget, vSelect},
    computed: {
      ...mapState("auth", ["currentUser"]),
      ...mapState("countries", ["selectedCountry", "countries"]),
      ...mapState("awards", ["awards", "isReceiving", "isDeleting"]),
    },
    watch: {
      selectedCountry: function (val) {
        this.getAwardsRequest(val.id);
      },
    },
    data() {
      return {
        user: JSON.parse(localStorage.getItem('user') || {}),
        awardPopover: {},
        awardPopover: {}
      };
    },
    methods: {
      ...mapActions("awards", ["getAwardsRequest", "deleteAwardRequest"]),
      ...mapActions("auth", ["fetchCurrentUser"]),

      closePopover(id) {
        this.awardPopover[id] = false;
      },
      hasAdminRole(isGlobal){
        const user = this.currentUser ? this.currentUser : this.user;

        if(user && this.countries && this.selectedCountry) {
          const selectedCountryId = this.selectedCountry.id;
          const selectedCountry = this.countries.filter(c => c.id == selectedCountryId )
          if (selectedCountry && selectedCountry.length > 0) {
            const countryData = selectedCountry[0];
            const userAuthorities = user.userAuthorities;
            const adminAuthorities = userAuthorities.filter(a => (a.role == 'ROLE_ADMIN' && countryData.code === a.tenantCode));
            const rootAuthorities = userAuthorities.filter(a => a.role == 'ROLE_ROOT');

            if (rootAuthorities.length > 0 || (adminAuthorities.length > 0 && !isGlobal)) {
              return true;
            }
          }
        }
        return false;
      },
    },
    async mounted() {
      if(this.currentUser == undefined || this.currentUser.id == null) {
        await this.fetchCurrentUser();
      }
      if(this.currentUser && this.currentUser.selectedCountryId){
        this.getAwardsRequest(this.currentUser.selectedCountryId);
      }
    }
  }
</script>

<style scoped/>
